module.exports = __webpack_public_path__ + "static/media/team-2.74a27205.jpg";